import React, { useState } from "react";
import { Link } from "react-router-dom";

import LayoutAuth from "../../components/layoutAuth";
import { authService } from "../../services/auth";
import { trackEvent } from "../../utils/tracking";

const ResetPasswordRequest = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submitForm = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    const email = e.target.elements["email"].value;

    authService.requestPasswordReset(
      email,
      () => {
        setSuccess(true);
        setLoading(false);
        trackEvent('request_password_reset');
      },
      (error, response) => {
        const err = response?.data?.error || "Could not send reset email";
        setError(err);
        setLoading(false);
      }
    );
  };

  return (
    <LayoutAuth
      title="Reset your password"
      subtitle="Enter your email and we'll send you a reset link."
    >
      {success ? (
        <div className="rounded-md p-4 border border-theme-secondary bg-theme-secondary bg-opacity-20">
          <p className="text-sm text-theme-text">
            If that email is registered, you will receive a reset link shortly.
          </p>
          <Link
            to="/login/"
            className="mt-2 inline-block text-sm font-medium text-theme-primary hover:opacity-80"
          >
            Back to sign in
          </Link>
        </div>
      ) : (
        <form className="space-y-6" action="#" onSubmit={submitForm}>
          {error ? (
            <div className="rounded-md p-4 border border-red-500 border-opacity-50 bg-red-500 bg-opacity-10">
              <p className="text-sm text-red-500">{error}</p>
            </div>
          ) : null}

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-theme-text"
            >
              Email address
            </label>
            <div className="mt-1">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                placeholder="you@example.com"
                className="appearance-none block w-full px-3 py-2 border border-theme-secondary rounded-md bg-theme-main shadow-sm text-theme-text placeholder-opacity-60 focus:outline-none focus:ring-theme-primary focus:border-theme-primary sm:text-sm"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="cursor-pointer w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-theme-button focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme-primary"
              disabled={loading}
              style={{
                backgroundColor: "var(--theme-primary)",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? "Sending..." : "Send reset link"}
            </button>
          </div>

          <div className="text-center text-sm">
            <Link
              to="/login/"
              className="font-medium text-theme-primary hover:opacity-80"
            >
              Back to sign in
            </Link>
          </div>
        </form>
      )}
    </LayoutAuth>
  );
};

export default ResetPasswordRequest;
